import { Button } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../../shared/utils/translationUtils";
import styles from "./style.less";

interface RatesLoadErrorProps {
  onRetry: () => void;
  isRetrying: boolean;
}

export const RatesLoadError = ({
  onRetry,
  isRetrying,
}: RatesLoadErrorProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={styles.container} role="alert" aria-busy={isRetrying}>
      <InfoCircleOutlined className={styles.icon} aria-hidden />

      <p className={styles.description}>
        {formatTranslation(t("errorBoundary.description"))}
      </p>

      <Button
        type="primary"
        loading={isRetrying}
        disabled={isRetrying}
        onClick={onRetry}
      >
        {formatTranslation(t("autozones.tryAgain"))}
      </Button>
    </div>
  );
};
